<script>
	import { writable } from 'svelte-persistent-store/dist/local'
	let token = writable('token', '')
</script>
